import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-role-landing',
  templateUrl: './service-role-landing.component.html',
  styleUrls: ['./service-role-landing.component.scss']
})
export class ServiceRoleLandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
